import React, { useState } from "react";
import ssoManagementService from "../../../services/SSOManagementService";
import { LTIPlatformDTO } from "@beable/roster-backend-client-v1";
import LTIPlatformForm from "../LTIPlatforms/LTIPlatformForm";
import FormModal, {
  ModalMessageSettings,
  getResultMessage,
} from "../../Common/FormModal";

interface AddLTIPlatformProps {
  open: boolean;
  handleClose: any;
}

export default function AddLTIPlatformModal(props: AddLTIPlatformProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [messageSetting, setMessageSetting] = useState<ModalMessageSettings>();

  const submitForm = async (ltiPlatform: LTIPlatformDTO, allEnvs: boolean) => {
    setIsLoading(true);
    const result = await ssoManagementService.addNewLTIPlatform(
      ltiPlatform,
      allEnvs
    );

    const message = getResultMessage(
      result,
      `LTI platform added successfully!`,
      `Failed to add this LTI platform!`
    );
    setMessageSetting(message);
    setIsLoading(false);
  };

  const handleClose = () => {
    props.handleClose(messageSetting?.severity === "success");
    setMessageSetting(undefined);
  }

  return (
    <FormModal
      isOpen={props.open}
      title="Add new LTI platform"
      description="Adds a new LTI platform to Beable."
      isLoading={isLoading}
      handleClose={handleClose}
      message={messageSetting}
    >
      <LTIPlatformForm
        onSubmit={submitForm}
        handleClose={handleClose}
      />
    </FormModal>
  );
}
